//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ResourceClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetResourceResourceQueryParameters = {
  id: number ;
}

export type EditResourceResourceQueryParameters = {
  id: number ;
}

export type RemoveResourceResourceQueryParameters = {
  id: number ;
}

export type GetResourcesResourceQueryParameters = {
  includeDeleted?: boolean | undefined ;
  resourceType?: Types.ResourceType | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export function getResourceUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/resources/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getResourceDefaultOptions: Omit<UseQueryOptions<Types.ResourceDto, unknown, Types.ResourceDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ResourceDto, unknown, Types.ResourceDto>, 'queryFn'>> = {
};
export function getGetResourceDefaultOptions() {
  return getResourceDefaultOptions;
};
export function setGetResourceDefaultOptions(options: typeof getResourceDefaultOptions) {
  getResourceDefaultOptions = options;
}

export function getResourceQueryKey(id: number): QueryKey;
export function getResourceQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetResourceResourceQueryParameters;

    return trimArrayEnd([
        'ResourceClient',
        'getResource',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'ResourceClient',
        'getResource',
        ...params
      ]);
  }
}
export function __getResource(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getResource(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetResourceQuery<TSelectData = Types.ResourceDto, TError = unknown>(dto: GetResourceResourceQueryParameters, options?: Omit<UseQueryOptions<Types.ResourceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a resource by id.
 * @param id The resource id.
 */
export function useGetResourceQuery<TSelectData = Types.ResourceDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.ResourceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetResourceQuery<TSelectData = Types.ResourceDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ResourceDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetResourceResourceQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ResourceDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getResource(context, axiosConfig) : __getResource,
    queryKey: getResourceQueryKey(id),
    ...getResourceDefaultOptions as unknown as Omit<UseQueryOptions<Types.ResourceDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a resource by id.
 * @param id The resource id.
 */
export function setGetResourceData(queryClient: QueryClient, updater: (data: Types.ResourceDto | undefined) => Types.ResourceDto, id: number) {
  queryClient.setQueryData(getResourceQueryKey(id),
    updater
  );
}

/**
 * Gets a resource by id.
 * @param id The resource id.
 */
export function setGetResourceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ResourceDto | undefined) => Types.ResourceDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editResourceUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/resources/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editResourceMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'ResourceClient',
      'editResource',
      id as any,
    ]);
}

/**
 * Edits a resource.
 * @param id The resource id.
 * @param updateResourceDto Request parameter
 */
export function useEditResourceMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateResourceDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateResourceDto, TContext> {
  const key = editResourceMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updateResourceDto: Types.UpdateResourceDto) => Client.editResource(id, updateResourceDto),
    mutationKey: key,
  });
}
  
type EditResource__MutationParameters = EditResourceResourceQueryParameters & {
  updateResourceDto: Types.UpdateResourceDto;
}

/**
 * Edits a resource.
 * @param id The resource id.
 * @param updateResourceDto Request parameter
 */
export function useEditResourceMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditResource__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditResourceResourceQueryParameters}): UseMutationResult<void, unknown, EditResource__MutationParameters, TContext> {
  const key = editResourceMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditResource__MutationParameters) => Client.editResource(data.id ?? options?.parameters?.id!, data.updateResourceDto),
  mutationKey: key,
});
}
  
export function removeResourceUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/resources/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeResourceMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'ResourceClient',
      'removeResource',
      id as any,
    ]);
}

/**
 * Removes a resource.
 * @param id The resource id.
 */
export function useRemoveResourceMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeResourceMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeResource(id),
    mutationKey: key,
  });
}
  
type RemoveResource__MutationParameters = RemoveResourceResourceQueryParameters

/**
 * Removes a resource.
 * @param id The resource id.
 */
export function useRemoveResourceMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveResource__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveResourceResourceQueryParameters}): UseMutationResult<void, unknown, RemoveResource__MutationParameters, TContext> {
  const key = removeResourceMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveResource__MutationParameters) => Client.removeResource(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getResourcesUrl(includeDeleted?: boolean | undefined, resourceType?: Types.ResourceType | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/resources?";
if (includeDeleted === null)
    throw new Error("The parameter 'includeDeleted' cannot be null.");
else if (includeDeleted !== undefined)
    url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
if (resourceType !== undefined && resourceType !== null)
    url_ += "ResourceType=" + encodeURIComponent("" + resourceType) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getResourcesDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfResourceDto, unknown, Types.PageableListDtoOfResourceDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfResourceDto, unknown, Types.PageableListDtoOfResourceDto>, 'queryFn'>> = {
};
export function getGetResourcesDefaultOptions() {
  return getResourcesDefaultOptions;
};
export function setGetResourcesDefaultOptions(options: typeof getResourcesDefaultOptions) {
  getResourcesDefaultOptions = options;
}

export function getResourcesQueryKey(dto: GetResourcesResourceQueryParameters): QueryKey;
export function getResourcesQueryKey(includeDeleted?: boolean | undefined, resourceType?: Types.ResourceType | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getResourcesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { includeDeleted, resourceType, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetResourcesResourceQueryParameters;

    return trimArrayEnd([
        'ResourceClient',
        'getResources',
        includeDeleted as any,
        resourceType as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'ResourceClient',
        'getResources',
        ...params
      ]);
  }
}
export function __getResources(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getResources(
      context.queryKey[2] as boolean | undefined,       context.queryKey[3] as Types.ResourceType | null | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as number | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortDirection | undefined,       context.queryKey[8] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetResourcesQuery<TSelectData = Types.PageableListDtoOfResourceDto, TError = unknown>(dto: GetResourcesResourceQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfResourceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all resources.
 * @param includeDeleted (optional) 
 * @param resourceType (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetResourcesQuery<TSelectData = Types.PageableListDtoOfResourceDto, TError = unknown>(includeDeleted?: boolean | undefined, resourceType?: Types.ResourceType | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfResourceDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetResourcesQuery<TSelectData = Types.PageableListDtoOfResourceDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfResourceDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let includeDeleted: any = undefined;
  let resourceType: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ includeDeleted, resourceType, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetResourcesResourceQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [includeDeleted, resourceType, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfResourceDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getResources(context, axiosConfig) : __getResources,
    queryKey: getResourcesQueryKey(includeDeleted, resourceType, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getResourcesDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfResourceDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all resources.
 * @param includeDeleted (optional) 
 * @param resourceType (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetResourcesData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfResourceDto | undefined) => Types.PageableListDtoOfResourceDto, includeDeleted?: boolean | undefined, resourceType?: Types.ResourceType | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getResourcesQueryKey(includeDeleted, resourceType, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets all resources.
 * @param includeDeleted (optional) 
 * @param resourceType (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetResourcesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfResourceDto | undefined) => Types.PageableListDtoOfResourceDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createResourceUrl(): string {
  let url_ = getBaseUrl() + "/api/resources";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createResourceMutationKey(): MutationKey {
  return trimArrayEnd([
      'ResourceClient',
      'createResource',
    ]);
}

/**
 * Creates a resource.
 * @param newResource Request parameter
 */
export function useCreateResourceMutation<TContext>(options?: Omit<UseMutationOptions<Types.ResourceDto, unknown, Types.CreateResourceDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ResourceDto, unknown, Types.CreateResourceDto, TContext> {
  const key = createResourceMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (newResource: Types.CreateResourceDto) => Client.createResource(newResource),
    mutationKey: key,
  });
}